import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUnits,
  fetchUnitById,
  updateUnit,
  updateStatusInUnit,
} from "./thunk";

interface UnitState {
  unitList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedUnits: any;
}

const initialState: UnitState = {
  unitList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedUnits: null,
};

const unitSlice = createSlice({
  name: "unit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnits.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUnits.fulfilled, (state, action) => {
        state.loading = false;
        state.unitList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchUnits.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchUnitById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUnitById.fulfilled, (state, action) => {
        state.loading = false;

        state.selectedUnits = action.payload;
      })
      .addCase(fetchUnitById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateUnit.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.unitList = state.unitList.map((unit) =>
          unit.id === action.payload.id ? action.payload : unit
        );
      })
      .addCase(updateUnit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Unit";
      })
      .addCase(updateStatusInUnit.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.unitList = state.unitList.map((unit) =>
        //   unit.id === action.payload.id ? action.payload : unit
        // );
      })
      .addCase(updateStatusInUnit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default unitSlice.reducer;
